import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Login } from './components/auth';
import { Privacy } from './components/common';
import { Dashboard } from './components/dashboard';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
  // Authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
  };

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return (
      <ThemeProvider>
        <Login onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  // Show app with routing if authenticated
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route 
            path="/" 
            element={<Dashboard user={user} onLogout={handleLogout} />} 
          />
          <Route 
            path="/privacy" 
            element={<Privacy />} 
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App; 